//
// InsightManager.js
// transport
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../lib";
import "./SubserviceManager";
import "./Voucher";
import "./warnings/TransportWarning";
import "../util/reportcentral/operations/AbstractOperation";

var InsightManager = createModule("transport::InsightManager", ["transport::SubserviceManager"], EventDispatcher, [
    ,
    ,
    ,
    ,
    {
        deleteAllInsights: [1],
        removeAllInsightsDeviceOnly: [1],
        createSyncInsightsOperation: [1],
        deleteInsight: [1,7],
        getInsightFolderPath: [7,7],
        createUpdateInsightOperation: [1,7,1,7],
        getInsightList: [1],
        createCreateAndSaveInsightOperation: [1,7,1],
    },
    ,
    ,
]);
export default InsightManager;
